import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ProjectTemplateCard from '../../../ProjectTypesContainer/ProjectTemplateCard';
import ExpandableSectionV2 from '../../../../components/ExpandableSection/ExpandableSectionV2';

import { useProjectTypeNavState } from './hooks/useProjectTypeNavState';
import { 
  buildProjectTemplateCards, 
  calculateExpandedState, 
} from './utils/navCardUtils';
import ProjectTypeName from './components/ProjectTypeName';
import ProjectTemplatesView from './components/ProjectTemplatesView';
import AddTemplateView from './components/AddTemplateView';

import './ProjectTypeNavCard.scss';

const ProjectTypeNavCard = ({
  project_type,
  selected,
  selectedProjectTemplate,
  selectedProjectType,
  currentUser,
  currentCompany,
  animateExpand,
  editProjectType,
  handleDeleteTemplate,
  handleUpdateProjectTypeTemplates,
  handleAddProjectTemplate,
  allTypes,
  closeoutTemplates,
  selectedCompany,
  markets,
  permissions,
  textMap,
  dataModel,
  id,
}) => {
  // Use custom hook for state management
  const {
    menu,
    isExpanded,
    userHasToggled,
    editingName,
    editProjectTypeState,
    addingTemplate,
    nameEditRef,
    addTemplateRef,
    parentRef,
    handleSetTitleElement,
    handleEditTemplateName,
    handleDeleteProjectTemplate,
    handleDeleteProjectType,
    handleEditProjectType,
    handleNameChange,
    handleIfProjectTypeAlreadyExists,
    handleProjectTypeUpdate,
    handleEditKeyDown,
    handleInputClick,
    toggleExpanded,
    handleAddProjectTemplateLocal: openTemplateView,
    handleCloseAddCard,
  } = useProjectTypeNavState({
    project_type,
    selectedProjectTemplate,
    selectedProjectType,
    selected,
    editProjectType,
    handleDeleteTemplate,
    handleAddProjectTemplate,
    handleUpdateProjectTypeTemplates,
    allTypes,
    textMap,
  });

  // Computed values
  const expanded = calculateExpandedState({
    selectedProjectTemplate,
    selectedProjectType,
    selected,
    project_type,
    isExpanded,
    userHasToggled,
  });

  const projectTemplateCards = buildProjectTemplateCards({
    project_type,
    selectedProjectTemplate,
    currentUser,
    currentCompany,
    animateExpand,
    handleDeleteProjectTemplate,
    handleUpdateProjectTypeTemplates,
    handleEditTemplateName,
    ProjectTemplateCard,
  });

  const projectTypeExist = editProjectTypeState && handleIfProjectTypeAlreadyExists(editProjectTypeState.name);

  // Render
  if (!project_type) {
    return null;
  }

  return (
    <div 
      className={'project-type-nav-card ' + (selected ? 'selected' : '')} 
      id={id} 
      ref={parentRef}
    >
      {/* Add Template View */}
      <AddTemplateView
        addingTemplate={addingTemplate}
        parentRef={parentRef}
        handleCloseAddCard={handleCloseAddCard}
        project_type={project_type}
        closeoutTemplates={closeoutTemplates}
        selectedCompany={selectedCompany}
        markets={markets}
        handleAddProjectTemplate={handleAddProjectTemplate}
        addTemplateRef={addTemplateRef}
      />

      <div className='info-line-anchor'>
        {/* Popup Menu */}
        {menu}
        
        <div className="info-line">
          <div className="project-type-info" onClick={toggleExpanded}>
            <ProjectTypeName
              editingName={editingName}
              editProjectType={editProjectTypeState}
              project_type={project_type}
              projectTypeExist={projectTypeExist}
              handleNameChange={handleNameChange}
              handleInputClick={handleInputClick}
              handleEditKeyDown={handleEditKeyDown}
              handleSetTitleElement={handleSetTitleElement}
              handleProjectTypeUpdate={handleProjectTypeUpdate}
              handleDeleteProjectType={handleDeleteProjectType}
              handleEditProjectType={handleEditProjectType}
              nameEditRef={nameEditRef}
            />
          </div>
        </div>

        {/* Expandable Section */}
        <ExpandableSectionV2 
          expanded={expanded}
          onExpand={toggleExpanded}
          key='project-type'
          animateExpand={animateExpand}
          name=""
        >
          <ProjectTemplatesView
            projectTemplateCards={projectTemplateCards}
            handleAddProjectTemplate={openTemplateView}
          />
        </ExpandableSectionV2>
        
        <hr className="underline" />
      </div>
    </div>
  );
};

ProjectTypeNavCard.propTypes = {
  project_type: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  selectedProjectTemplate: PropTypes.object,
  selectedProjectType: PropTypes.object,
  currentUser: PropTypes.object.isRequired,
  currentCompany: PropTypes.object.isRequired,
  animateExpand: PropTypes.bool,
  editProjectType: PropTypes.func,
  handleDeleteTemplate: PropTypes.func.isRequired,
  handleAddProjectTemplate: PropTypes.func.isRequired,
  handleUpdateProjectTypeTemplates: PropTypes.func.isRequired,
  allTypes: PropTypes.array.isRequired,
  closeoutTemplates: PropTypes.array,
  selectedCompany: PropTypes.object,
  markets: PropTypes.array,
  permissions: PropTypes.object,
  textMap: PropTypes.object.isRequired,
  dataModel: PropTypes.object.isRequired,
  id: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: require('../../../../models/DataModel').default,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(ProjectTypeNavCard);



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeNavCard/index.js